exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".site-name-banner{position:fixed;top:0;left:0;background:red;color:#fff;text-align:center;font-weight:700;z-index:999999;font-size:.8em;padding:2px 4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/components/common/layouts/environment.banner.css
// module id = 1111
// module chunks = 0